'use strict'

import Vue from 'vue'

import CodeInput from './CodeInput.vue'
import ToolInput from './ToolInput.vue'

Vue.component('code-input', CodeInput)
Vue.component('tool-input', ToolInput)

